import { useState, useEffect } from "react";
import { useAuthStore } from "../store/authStore";
import { getApiUrl } from "../api";

export function usePoints() {
  const { isLoggedIn } = useAuthStore();
  const [points, setPoints] = useState<number | null>(null);

  useEffect(() => {
    if (!isLoggedIn) return;
    const token = localStorage.getItem("access_token");
    fetch(getApiUrl("/marubit/api/member/me/home-info"), {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(data => {
        setPoints(data.total_points);
        // 회원번호가 스토어에 없으면(기존 로그인 세션 등) 보강
        if (data.unique_member_no && useAuthStore.getState().uniqueMemberNo !== data.unique_member_no) {
          localStorage.setItem("unique_member_no", data.unique_member_no);
          useAuthStore.setState({ uniqueMemberNo: data.unique_member_no });
        }
      })
      .catch(() => setPoints(null));
  }, [isLoggedIn]);

  return points;
}